import createIcon from '../../createIcon';

/**
 * @component @name Hvac
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMTZDMTMuMDEgMTYgMTMuOTEgMTUuNjEgMTQuNjIgMTVIOS4zOEMxMC4wOSAxNS42MSAxMC45OSAxNiAxMiAxNloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik04LjU2IDE0SDE1LjQ1QzE1LjcxIDEzLjU1IDE1Ljg5IDEzLjA0IDE1Ljk2IDEyLjVIOC4wNkM4LjEyIDEzLjA0IDguMjkgMTMuNTUgOC41NiAxNFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMiA4QzEwLjk5IDggMTAuMDkgOC4zOSA5LjM4IDlIMTQuNjJDMTMuOTEgOC4zOSAxMy4wMSA4IDEyIDhaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNOC41NiAxMEM4LjMgMTAuNDUgOC4xMiAxMC45NiA4LjA1IDExLjVIMTUuOTVDMTUuODggMTAuOTYgMTUuNzEgMTAuNDUgMTUuNDQgMTBIOC41NloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xOSAzSDVDMy45IDMgMyAzLjkgMyA1VjE5QzMgMjAuMSAzLjkgMjEgNSAyMUgxOUMyMC4xIDIxIDIxIDIwLjEgMjEgMTlWNUMyMSAzLjkgMjAuMSAzIDE5IDNaTTEyIDE4QzguNjkgMTggNiAxNS4zMSA2IDEyQzYgOC42OSA4LjY5IDYgMTIgNkMxNS4zMSA2IDE4IDguNjkgMTggMTJDMTggMTUuMzEgMTUuMzEgMTggMTIgMThaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Hvac = createIcon('Hvac', [
  [
    'path',
    { d: 'M12 16C13.01 16 13.91 15.61 14.62 15H9.38C10.09 15.61 10.99 16 12 16Z', key: '154ggg' },
  ],
  [
    'path',
    {
      d: 'M8.56 14H15.45C15.71 13.55 15.89 13.04 15.96 12.5H8.06C8.12 13.04 8.29 13.55 8.56 14Z',
      key: '186elt',
    },
  ],
  ['path', { d: 'M12 8C10.99 8 10.09 8.39 9.38 9H14.62C13.91 8.39 13.01 8 12 8Z', key: 'b2onu9' }],
  [
    'path',
    {
      d: 'M8.56 10C8.3 10.45 8.12 10.96 8.05 11.5H15.95C15.88 10.96 15.71 10.45 15.44 10H8.56Z',
      key: '189j47',
    },
  ],
  [
    'path',
    {
      d: 'M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM12 18C8.69 18 6 15.31 6 12C6 8.69 8.69 6 12 6C15.31 6 18 8.69 18 12C18 15.31 15.31 18 12 18Z',
      key: '2jor4l',
    },
  ],
]);

export default Hvac;
